// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__BQPCS","buttons":"Footer_buttons__3BCRJ"};